import React from 'react';
import { Users, Briefcase, Heart, Globe, ShieldCheck, DollarSign, Layers, Tag, Award } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function PersonasParametrizacion() {
    const items = [
        { title: 'Profesiones', icon: Briefcase, href: '/parametrizacion/profesiones', color: 'bg-purple-500' },
        { title: 'Parentescos', icon: Users, href: '/parametrizacion/parentescos', color: 'bg-pink-400' },
        { title: 'Estados Civiles', icon: Heart, href: '/parametrizacion/estados-civiles', color: 'bg-pink-500' },
        { title: 'Géneros', icon: Users, href: '/parametrizacion/generos', color: 'bg-blue-300' },
        { title: 'Nacionalidades', icon: Globe, href: '/parametrizacion/nacionalidades', color: 'bg-green-500' },
        { title: 'Estados de Socio', icon: ShieldCheck, href: '/parametrizacion/estados-socio', color: 'bg-green-700' },
        { title: 'Tipos de Ingresos', icon: DollarSign, href: '/parametrizacion/tipos-ingreso', color: 'bg-yellow-600' },
        { title: 'Tipos de Socio', icon: Users, href: '/parametrizacion/tipos-socio', color: 'bg-blue-600' },
        { title: 'Categorías de Socio', icon: Tag, href: '/parametrizacion/categorias', color: 'bg-teal-600' },
        { title: 'Gestión de Antigüedad', icon: Layers, href: '/parametrizacion/rangos-antiguedad', color: 'bg-gray-500' },
        { title: 'Niveles de Fidelidad', icon: Award, href: '/parametrizacion/niveles-fidelidad', color: 'bg-indigo-500' },
    ];

    return (
        <div className="p-6">
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                <div className="px-6 py-4 flex items-center space-x-4 bg-indigo-100 text-indigo-800">
                    <Users className="w-8 h-8 opacity-80" />
                    <div>
                        <h3 className="text-xl font-bold">1. Módulo: Gestión de Personas y Socios</h3>
                        <p className="text-sm opacity-90">Este grupo contiene todo lo que define el "Quién".</p>
                    </div>
                </div>

                <div className="p-6">
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                        {items.map((table, idx) => (
                            <Link
                                key={idx}
                                to={table.href}
                                className="bg-gray-50 text-gray-800 border-gray-100 hover:bg-opacity-90 p-4 rounded-xl shadow-sm hover:shadow-md transition-all border flex flex-col items-center text-center group"
                            >
                                <div className={`p-3 rounded-full ${table.color} bg-opacity-10 mb-3 group-hover:scale-110 transition-transform`}>
                                    <table.icon className={`w-6 h-6 ${table.color.replace('bg-', 'text-')}`} />
                                </div>
                                <h4 className="font-bold text-sm text-gray-800 group-hover:text-blue-600 transition-colors leading-tight">{table.title}</h4>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
